export const urlSegments = {
  type: 'type=1720077073',
  controller: 'tx_mysysmexdocuments_watchlist[controller]=Documents',
  guid: 'tx_mysysmexdocuments_watchlist[guid]=',
  actions: {
    get: 'tx_mysysmexdocuments_watchlist[action]=getWatchlist',
    add: 'tx_mysysmexdocuments_watchlist[action]=addToWatchlist',
    remove: 'tx_mysysmexdocuments_watchlist[action]=removeFromWatchlist',
    clear: 'tx_mysysmexdocuments_watchlist[action]=clearWatchlist'
  }
}

export const fetchUrls = {
  get: `${urlSegments.controller}&${urlSegments.actions.get}&${urlSegments.type}`,
  clear: `${urlSegments.controller}&${urlSegments.actions.clear}&${urlSegments.type}`,
  add: `${urlSegments.controller}&${urlSegments.actions.add}&${urlSegments.type}&${urlSegments.guid}`,
  remove: `${urlSegments.controller}&${urlSegments.actions.remove}&${urlSegments.type}&${urlSegments.guid}`
}
